module.exports = __webpack_public_path__ + "static/Dynamo-6840989a5dbedbb302be27c003d291bc.jpg";